module.exports = __webpack_public_path__ + "static/media/25UNHCR3.9fee8575.jpg";